<template>
  <div class="example-simple">
    <el-container>
      <el-header> {{$t('lang.title')}} </el-header>
      <el-main>
        <el-row>
          睿连智行（RiderLink）是一款专门为两轮车车主而设计的手机辅助驾驶软件。
        </el-row>
        <el-row>
          1.支持APP和两轮车仪表之间的无感自动连接。
        </el-row>
        <el-row>
          2.连接成功后，用户在手机端进行导航后，支持仪表端显示导航信息，使驾驶骑行更安全便捷。
        </el-row>
        <el-row>
          3.应用内置高德导航，支持简易导航，导航画面导航等模式。
        </el-row>
        <el-row>
          4.可扩展支持仪表端行车记录仪的录影文件浏览和下载。
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-button @click="download()"
                     type="primary">
            {{$t('lang.download')}}
          </el-button>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <div>
            <p>
              版权所有 凌阳成芯科技（成都）有限公司
            </p>
            <p><a href="https://beian.miit.gov.cn"
                 target="_blank">蜀ICP备13001769号-5</a></p>
          </div>
        </el-row>
        <el-row>
          <div>
            <router-link to="privacy">隐私策略</router-link>
          </div>
        </el-row>
        <el-row>
          <div style="width:300px;margin:0 auto; padding:20px 0;">
            <a target="_blank"
               href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002005652"
               style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="@/assets/beian.png"
                   style="float:left;" />
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">川公网安备 51019002005652号</p>
            </a>
          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'DownloadWorld',
  data () {
    return {
      msg: 'Welcome to download Riderlink App'
    }
  },
  methods: {
    download () {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {

      }

      if (/android/i.test(userAgent)) {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.link.rider'
        return
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href = 'https://apps.apple.com/cn/app/%E7%9D%BF%E8%BF%9E%E6%99%BA%E8%A1%8C/id6443478696'
        return
      }
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.link.rider'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-header {
  background-color: #409eff;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-row {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Download.vue